const createURL = (origin) => {
    try {
        return new URL(origin);
    }
    catch (err) {
        try {
            // During this attempt we're checking if a scheme was missing in the origin as
            // Platforms may or may nor include it.
            return new URL(`https://${origin}`);
        }
        catch (err) {
            // ToDo: accept a logger dep and log an error here
            return null;
        }
    }
};
export const tryParsingSIWE = ({ message, messageType, origin: _origin, simulationResult, }) => {
    if (messageType === 1 /* MessageTypeEnum.TypedData */) {
        return;
    }
    const origin = createURL(_origin);
    if (!origin) {
        return;
    }
    /*
      Some dApps don't comply with EIP-4361 and use their custom Sign-In messages. This code block detects such known custom SIWE messages.
     */
    if (origin.hostname === 'rarible.com' &&
        message.includes('I want to login on Rarible')) {
        simulationResult.kind = {
            kind: 'SIWE',
            info: {
                date: new Date(),
                statement: 'I accept the Rarible Terms of Service https://static.rarible.com/terms.pdf and I am at least 13 years old.',
            },
        };
    }
    // TODO: add proper EIP-4361 parsing.
    return;
};
